// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2agf8","file":"styles_file__3uZ79"};